import FeatureLayer from '@arcgis/core/layers/FeatureLayer';

/**
 * Feature layer for Elvia's responsibility area.
 * Darkens areas that are not in Elvia's area.
 */
export const areaLayer = new FeatureLayer({
  url: 'https://services-eu1.arcgis.com/AcdYbPzrkOfBOQDL/arcgis/rest/services/Konsesjonsomraade_invertert/FeatureServer',
  layerId: 0,
  opacity: 0.6,
});
